const pick = (lines) => lines[Math.floor(Math.random() * lines.length)];

const WRONG_ANSWER_LINES = [
  'Wrong. The Rainbow Index is a law score, not a vibe check.',
  'You just ranked a criminalization statute over marriage equality. Bold. Incorrect.',
  'That’s not how the numbers work, cartographer.',
  'You treated “gayer” like a stereotype. The card wanted the bigger (or smaller) number.',
  'Compass says no. Also the index says no.',
  'You clocked Malta as less gay-friendly than a country that still jails people. Sit down.',
  'Wrong continent, wrong statute, wrong Pride float.',
  'The Equality Index hung up on you.',
];

const RANKS = [
  {
    max: 0,
    animal: 'Snail',
    messages: [
      "Snail rank! 🐌 Zero. You looked at two rights scores and invented a stereotype. Magellan would revoke your passport and hand you the ILGA PDF.",
      "Snail rank! 🐌 You didn’t leave the harbor. Spain’s Rainbow Index is a statute count, not a feeling you had about the flag colors.",
      "Snail rank! 🐌 You picked with your gut. The gut is not a legal index. GPS would file a missing-person report for your reading comprehension.",
    ],
  },
  {
    max: 3,
    animal: 'Turtle',
    messages: [
      "Turtle mode! 🐢 One decent pick, then you treated Uganda’s legal score like a vibe and the Netherlands like a rumor.",
      "Turtle mode! 🐢 Slow, lost, and convinced “marriage equality since 2001” was a trivia year you could ignore.",
      "Turtle mode! 🐢 You’d follow a Pride map into a wall. The number on the card is the whole assignment.",
    ],
  },
  {
    max: 7,
    animal: 'Rabbit',
    messages: [
      "Rabbit rank! 🐇 Mid at best. Don’t get hoppy — Rainbow Index 89 beats Rainbow Index 2 even if the flags confuse you.",
      "Rabbit rank! 🐇 A few correct guesses, then you mixed a legal-protection score with a hunch about who parties more.",
      "Rabbit rank! 🐇 Average with extra steps. You’d land in Iceland and ask where the criminalization clause is.",
    ],
  },
  {
    max: 12,
    animal: 'Wolf',
    messages: [
      "Wolf rank? 🐺 Barely. A little above average isn’t a personality. The index still thinks you skip the labels.",
      "Wolf rank? 🐺 The pack would leave you at the visitor center with a copy of Equaldex. You still think “gayer” means the flag looks louder.",
      "Wolf rank? 🐺 Not a disaster, which is the nicest thing anyone will say until you stop ranking statutes by stereotype.",
    ],
  },
  {
    max: 19,
    animal: 'Cheetah',
    messages: [
      "Cheetah? 🐆 Don’t. A decent streak isn’t a human-rights degree. You almost had a real run, which is a fancy way of saying you still missed the number.",
      "Cheetah? 🐆 Close-ish. You’d still put a criminalizing statute over Malta and call it intuition. Come back at 20.",
      "Cheetah? 🐆 Don’t frame this. Rights-index tourists with this score get a participation rainbow and a lecture about reading the metric label.",
    ],
  },
  {
    max: 24,
    animal: 'Falcon',
    messages: [
      "Falcon-level rights trivia! 🦅 That’s actually impressive. You compared indexes like you own the ILGA spreadsheet — then still walked off the map.",
      "Falcon-level memory of the Rainbow Map! 🦅 Rare praise: you earned it. Shame the last pick treated 89 and 2 as a coin flip.",
    ],
  },
  {
    max: Infinity,
    animal: 'Peregrine Falcon',
    messages: [
      "Peregrine Falcon! 🦅 Are you even human? Equaldex wishes its own interns had this many correct turns. Then you still found a way to miss.",
      "Peregrine Falcon! 🦅 Atlas menace. That streak was real — the last miss is the only proof you’re mortal.",
    ],
  },
];

export const pickWrongAnswerRoast = () => pick(WRONG_ANSWER_LINES);

export const getWhichCountryIsGayerRank = (score) => {
  const n = Number(score);
  const value = Number.isFinite(n) && n > 0 ? n : 0;
  const rank = RANKS.find((entry) => value <= entry.max) || RANKS[RANKS.length - 1];
  return {
    animal: rank.animal,
    message: pick(rank.messages),
  };
};
